module.exports = __webpack_public_path__ + "ab6c460851e5d5c5b498e734f6a65365.png";